class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.navToggle = self.elem.querySelector('[data-nav-toggle]');
        self.nav = self.elem.querySelector('[data-nav]');
        self.onEscape = self.onEscape.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.navToggle.addEventListener('click', evt => {
            evt.preventDefault();

            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });

        if(self.nav.classList.contains('is-open')) {
            self.open();
        }
    }

    open() {
        let self = this;
        
        // Add is-active class to hamburger
        self.navToggle.classList.add('is-active');

        // Set aria-expanded attribute to true
        self.navToggle.setAttribute('aria-expanded', true);

        // Activate the nav
        self.nav.classList.add('is-active');

        // Add .nav-is-open class to body
        self.elem.classList.add('nav-is-open');

        // Disable scrolling on body
        self.elem.classList.add('is-no-scroll');
        
        // Add event listeners
        self.addEventListeners();

        self.isOpen = true;
    }

    close() {
        let self = this;

        // Remove is-active class from hamburger
        self.navToggle.classList.remove('is-active');

        // Set aria-expanded attribute to false
        self.navToggle.setAttribute('aria-expanded', false);

        // Close the nav
        self.nav.classList.remove('is-active');

        // Remove .nav-is-open class from body
        self.elem.classList.remove('nav-is-open');

        // Enable scrolling on body
        self.elem.classList.remove('is-no-scroll');
        
        // Remove event listeners
        self.removeEventListeners();

        self.isOpen = false;
    }

    addEventListeners() {
        let self = this;

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }
}

export default Nav;